export default __webpack_public_path__ + "static/media/hotelbooking.db944f9f.png";